import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ButtonPushComponent, TitleComponent } from "../../components";
import { ModalLayout } from "../../layouts";
import { requestPostAuthorization } from "../../services/requestPost";
import { cleanCreateModifier } from "../../store/modifier";
import { ModalContainer } from "../ModalContainer/ModalContainer";

export const ModifierCreateHeaderContainer = () => {
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const body = useSelector((state) => state.createModifier);
  const onOpenConfirmd = () => {
    setIsOpenConfirm(!isOpenConfirm);
  };
  const dispatch = useDispatch();
  const createNote = () => {
    const token = localStorage.getItem("token");
    requestPostAuthorization(`admin/modificadores/`, body, token);
    dispatch(cleanCreateModifier());
  };
  const canceledStateStyle = {
    fontSize: "15px",
    fontWeight: "bold",
  };
  return (
    <div className="modifierCreateHeaderContainer ">
      <div className="modifierCreateHeaderContainer__title">
        <TitleComponent title="Detalle del Modificador" />
      </div>
      <div className="modifierCreateHeaderContainer__container-button">
        <ButtonPushComponent name={"Guardar"} onClick={onOpenConfirmd} />
      </div>
      {isOpenConfirm && (
        <ModalLayout>
          <ModalContainer
            title="Crear Modificador"
            msg="¿Está seguro que desea crear el modificador?"
            style={canceledStateStyle}
            onClose={onOpenConfirmd}
            onConfirm={createNote}
          />
        </ModalLayout>
      )}
    </div>
  );
};
